export default function createUndoHistoryBreak(editor) {
  editor.writeHistory('undos', {
    operations: [],
    selectionBefore: editor.selection,
  });
}
